import { getDoctorDashboardState } from "modules/doctor-dashboard/store/doctor-dashboard.selectors";
import { createSelector } from "reselect";

export class DoctorsDashboardOrganizationsSelectors {
    static readonly state = createSelector(getDoctorDashboardState, state => state.organizations);

    static readonly inProcess = createSelector(DoctorsDashboardOrganizationsSelectors.state, state => state.inProcess);
    static readonly organizations = createSelector(DoctorsDashboardOrganizationsSelectors.state, state => state.organizations);
}